cockpitApp.controller('flightBodySummaryController', [
  '$scope', 'segmentHelper',
  function($scope, segmentHelper)
  {
    $scope.segmentHelper = segmentHelper;
  }
]);
